import Axios from "axios";
import numeral from "numeral";

const storeFactory = () => {
    const urlRoot = "frontend/api/v1/user-preferences";
    let store = {
        namespaced: true,
        state: {},
        mutations: {},
        actions: {},
        getters: {}
    };

    store.state = {
        preferences: {},
    };
    store.mutations["SET_PREFERENCES"] = function (state, newVal) {
        state.preferences = newVal
    }
    store.actions["FETCH_PREFERENCES"] = async ({commit}, {username}) => {
        const entries = (await Axios.get(urlRoot)).data;
        const foundEntry = entries.find(entry => entry.username === username);

        const userPreference = foundEntry || {
            preferences: {
                defaultDecimalPlaces: 1,
                defaultNumberSeparator: ".",
                defaultThousandSeparator: " ",

                cashFlowDecimalPlaces: 2,
            }
        }

        commit("SET_PREFERENCES", userPreference)

        numeral.localeData().delimiters.thousands = userPreference.preferences.defaultThousandSeparator;
        numeral.localeData().delimiters.decimal = userPreference.preferences.defaultNumberSeparator;
    }
    store.actions["SAVE_PREFERENCES"] = async ({}, userPreferences) => {
        await Axios.post(urlRoot, userPreferences);
    }
    store.getters["getPreference"] = (state) => (key) => {
        return state.preferences.preferences[key];
    }
    return store;
}

export default storeFactory